"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useDislike, useLike, useLikes } from "@/features/engagement/hooks/use-likes";
type LikesProps = {
  slug: string;
};
function Likes(t0) {
  const $ = _c(20);
  const {
    slug
  } = t0;
  const {
    data: likes,
    isPending,
    isError
  } = useLikes(slug);
  const {
    mutate: addLike
  } = useLike(slug);
  const {
    mutate: addDislike
  } = useDislike(slug);
  if (isPending || isError) {
    return null;
  }
  let t1;
  if ($[0] !== addLike) {
    t1 = () => addLike();
    $[0] = addLike;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ThumbsUp />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== likes.count || $[4] !== likes.userLiked) {
    t3 = <Button type="submit" variant="outline" disabled={likes.userLiked}>{t2}{likes.count}</Button>;
    $[3] = likes.count;
    $[4] = likes.userLiked;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <form action={t1}>{t3}</form>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== addDislike) {
    t5 = () => addDislike();
    $[9] = addDislike;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ThumbsDown />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== likes.userLiked) {
    t7 = <Button type="submit" variant="outline" disabled={likes.userLiked}>{t6}</Button>;
    $[12] = likes.userLiked;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <form action={t5}>{t7}</form>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <div className="flex flex-col gap-6"><div className="flex flex-row gap-2">{t4}{t8}</div></div>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export default Likes;